import React, { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import { Card, CardContent, CardHeader, Grid, Typography, Divider } from "@mui/material";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";

import MappingToolBar from "../../../../components/MappingToolbar";
import MapPlanModal from "./MapPlanModal";
import { useDialog } from "../../../../contexts/DialogContext";
import { getTimeStamp } from "../../../../utils/common";
import MappedPlan from "./MappedPlan";
import SimpleTable from "./SimpleTable";
import { useFormContext } from "react-hook-form";
import CustomTextField from "../../../../components/CustomTextField";
import { useTranslation } from "react-i18next";

const AllowedPlan = ({ tenantId, fields }) => {
  const { t } = useTranslation();
  const { openDialog } = useDialog();
  const {
    register,
    formState: { errors },
    watch,
    control,
    setValue,
  } = useFormContext();

  const businessType = watch("businessType");

  const serviceType = watch("serviceType");
  const sharingType = watch("sharingType");
  const msoSharing = watch("msoSharing");
  const distSharing = watch("distSharing");
  const lcoSharing = watch("lcoSharing");
  const ottMsoSharing = watch("ottMsoSharing");
  const ottDistSharing = watch("ottDistSharing");
  const ottLcoSharing = watch("ottLcoSharing");

  const [isSharingAllowed, setIsSharingAllowed] = useState(false);

  useEffect(() => {
    setIsSharingAllowed(businessType == "LOCAL_CABLE_OPERATOR");
  }, [serviceType]);

  const allowedPlansValues = watch("allowedPlans");

  useEffect(() => {
    if (sharingType == "FIXED") {
      const updatedPlans = allowedPlansValues.map((plan) => ({
        ...plan, // keep existing planId or other fields
        msoSharing,
        distSharing,
        lcoSharing,
        ottMsoSharing,
        ottDistSharing,
        ottLcoSharing,
      }));
      console.log(updatedPlans, "updatedPlans");
      setValue("allowedPlans", updatedPlans);
    }
  }, [msoSharing, distSharing, lcoSharing, ottMsoSharing, ottDistSharing, ottLcoSharing]);

  const allowedPlans = watch("allowedPlans");

  const openDownloadDialog = () => {
    return openDialog(
      "map_plan_modal",
      "Mapping Plan",
      <MapPlanModal
        tenantId={tenantId}
        key={getTimeStamp()}
        isNew={true}
        isSharingAllowed={isSharingAllowed}
        serviceType={serviceType}
        multiple={sharingType == "FIXED"}
        sharingType={sharingType}
        sharing={[
          msoSharing,
          distSharing,
          lcoSharing,
          ottMsoSharing,
          ottDistSharing,
          ottLcoSharing,
        ]}
        allowedPlans={allowedPlans}
        setParentValue={setValue}
      />,
      "lg",
    );
  };

  return (
    <Card mb={6}>
      <CardHeader action={<MappingToolBar openDialog={openDownloadDialog} />} />
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t("Sharing")}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={12} className="row" pt={8}>
          {isSharingAllowed && (
            <Grid item md={3}>
              <CustomTextField
                label={t("mso_sharing")}
                name="msoSharing"
                type="text"
                my={2}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={fields}
                disabled={sharingType == "POLICY_WISE"}
              />
            </Grid>
          )}
          {isSharingAllowed && (
            <Grid item md={3}>
              <CustomTextField
                label={t("dist_sharing")}
                name="distSharing"
                type="text"
                my={2}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={fields}
                disabled={sharingType == "POLICY_WISE"}
              />
            </Grid>
          )}
          {isSharingAllowed && (
            <Grid item md={3}>
              <CustomTextField
                label={t("lco_sharing")}
                name="lcoSharing"
                type="text"
                my={2}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={fields}
                disabled={sharingType == "POLICY_WISE"}
              />
            </Grid>
          )}
        </Grid>
        {serviceType == "INTERNET_OTT" && (
          <Grid container spacing={12} className="row" pt={8} id="ott_sharing">
            {isSharingAllowed && (
              <Grid item md={3}>
                <CustomTextField
                  label={t("ottMsoSharing")}
                  name="ottMsoSharing"
                  type="text"
                  my={2}
                  control={control}
                  fullWidth
                  variant="outlined"
                  errors={errors}
                  fields={fields}
                  disabled={sharingType == "POLICY_WISE"}
                />
              </Grid>
            )}
            {isSharingAllowed && (
              <Grid item md={3}>
                <CustomTextField
                  label={t("ottDistSharing")}
                  name="ottDistSharing"
                  type="text"
                  my={2}
                  control={control}
                  fullWidth
                  variant="outlined"
                  errors={errors}
                  fields={fields}
                  disabled={sharingType == "POLICY_WISE"}
                />
              </Grid>
            )}
            {isSharingAllowed && (
              <Grid item md={3}>
                <CustomTextField
                  label={t("ottLcoSharing")}
                  name="ottLcoSharing"
                  type="text"
                  my={2}
                  control={control}
                  fullWidth
                  variant="outlined"
                  errors={errors}
                  fields={fields}
                  disabled={sharingType == "POLICY_WISE"}
                />
              </Grid>
            )}
          </Grid>
        )}
        <Typography variant="h6" gutterBottom sx={{ mt: 10 }}>
          {t("Assigned Plans")}
        </Typography>
        <Divider sx={{ mb: 10 }} />
        <SimpleTable tenantId={tenantId} />
      </CardContent>
    </Card>
  );
};

export default AllowedPlan;
